import CalendarRouter from 'commons/routers/Calendar.js';
import Employees from 'newCollections/employees';
import CompanyLocations from 'newCollections/company-locations.js';
import CompanyLocation from 'newModels/company-location.js';
import Holidays from 'newCollections/holidays.js';
import MainView from '../views/requestLeave/Main.js';

module.exports = CalendarRouter.extend({
    initialize: function() {
        this.LeaveMainView = MainView;
        CalendarRouter.prototype.initialize.apply(this, arguments);
    },

    _fetchCalendarData: function(locationId) {
        const locationPromise = locationId ?
            new CompanyLocation({objectId: locationId}).fetch() :
            Promise.resolve(null);
        return locationPromise
            .then(location => {
                const holidayOptions = {company: app.company};
                let employeeWhere = {};

                if (location) {
                    employeeWhere.companyLocationId = location.id;
                    holidayOptions.location = location;
                }

                // Employees with companyLocationId set to null are considered
                // to be in HQ
                // NOTE this is a hack because of an issue in the staging
                // database and PP1.0. Once fixed this block can be removed
                if (location && location.get('primary')) {
                    employeeWhere = {or: [
                        {
                            hiddenAt: null,
                            companyLocationId: location.id
                        },
                        {
                            hiddenAt: null,
                            companyLocationId: null
                        }
                    ]};
                }

                return Promise.all([
                    new Employees(null, {
                        company: app.company,
                        pagination: false
                    }).fetch({
                        filter: {
                            where: employeeWhere,
                            limit: 9999
                        },
                        validate: false
                    }),
                    new CompanyLocations(null, {
                        company: app.company,
                        pagination: false
                    }).fetch({
                        filter: {where: {hiddenAt: null}}
                    }),
                    new Holidays(null, holidayOptions).fetch(),
                    Promise.resolve(location)
                ]);
            })
            .then(([employees, locations, holidays, selectedLocation]) => {
                const enabledHolidays = selectedLocation ?
                    holidays.filter(h => h._enabled) : holidays;

                return {
                    employees,
                    locations,
                    selectedLocation,
                    holidays: enabledHolidays,
                    isEmployer: true
                };
            });
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Calendar.js